import React from 'react';
import classNames from 'classnames';
import cx from 'classnames';

import { ButtonVariants } from '../Button';

import styles from './index.module.scss';

export type OuterLinkProps = {
  variant?:
    | 'primary'
    | 'outlined'
    | 'text'
    | 'elevated'
    | 'tonal'
    | 'outlinedGradient';
  size?: 'small' | 'normal';
  children: React.ReactNode;
  href: string;
  innerRef?: React.RefObject<HTMLAnchorElement>;
  className?: string;
  disabled?: boolean;
  textClassName?: string;
};

const OuterLink: React.FC<OuterLinkProps> = ({
  variant = 'primary',
  size = 'normal',
  children,
  href,
  innerRef,
  className,
  disabled,
  textClassName,
}) => {
  const linkClassName = classNames(
    styles.normal,
    styles[size],
    styles[variant],
  );

  const isOutlinedGradient = variant === ButtonVariants.OUTLINED_GRADIENT;
  const isElevated = variant === ButtonVariants.ELEVATED;
  const isSizeSmall = size === 'small';

  const renderContent = () => {
    if (isOutlinedGradient) {
      return (
        <span
          className={cx(styles.gradientContent, {
            [styles.smallGradientContent]: isSizeSmall,
          })}
        >
          <span className={styles.gradientText}>{children}</span>
        </span>
      );
    }

    if (isElevated) {
      return (
        <span className={cx(styles.elevatedText, textClassName)}>
          {children}
        </span>
      );
    }

    return children;
  };

  return (
    <a
      className={cx(
        {
          [linkClassName]: true,
          [styles.disabled]: disabled,
        },
        className && { [className]: true },
      )}
      href={href}
      ref={innerRef}
      target='_blank'
      rel='noopener noreferrer'
      aria-disabled={disabled}
    >
      {renderContent()}
    </a>
  );
};

export default OuterLink;
